import { AnalysisType } from 'projects/dop-ordering/src/public-api';
import { CommercialItemValidationResponse } from '../../models/commercial-item-validation-response.model';
import { CommercialItem } from '../../models/commercial-item.model';
import { SalesCatalogueApplicability } from '../../models/legacy-matrix-applicability/sales-catalogue-applicability.model';
import { MemberType, SalesCatalogueResponse } from '../../models/sales-catalogue.model';

export class SalesCatalogueCommercialItemRule {

    constructor(
        public salesCatalogueCommercialItems: SalesCatalogueResponse,
        public useMatrix: boolean,
        public salesCatalogueApplicability?: SalesCatalogueApplicability[]) { }

    validateSalesCatalogueTest(testCode: string, salesCatalogueCode: string): CommercialItemValidationResponse {
        const validCiMember: { data?: CommercialItem, currencyCode?: string } = {};
        if (!(this.useMatrix && this.salesCatalogueApplicability.filter(x => x.commercialItemCode.indexOf(testCode) !== -1).length === 0)) {
            const tempCiItem = this.salesCatalogueCommercialItems.salesCatalogues.find(x => x.code === salesCatalogueCode);
            if (tempCiItem) {
                const temp = tempCiItem.members?.find(member => member.type === MemberType.Test && member.code === testCode);
                if (temp) {
                    validCiMember.currencyCode = tempCiItem.currencyCode;
                    validCiMember.data = {
                        invoiceableItemParentCode: salesCatalogueCode,
                        code: temp.code,
                        name: temp.name,
                        comment: '',
                        price: temp.price,
                        type: AnalysisType.SalesCatalogueTest,
                    };
                }
            }
        }
        return {
            data: validCiMember?.data,
            currencyCode: validCiMember?.currencyCode,
            isValid: validCiMember && validCiMember.data !== undefined,
        };
    }

    validateSalesCataloguePackageCode(packageCode: string, salesCatalogueCode: string): CommercialItemValidationResponse {
        const validCiMember: { data?: CommercialItem, currencyCode?: string } = {};
        if (!(this.useMatrix &&
            this.salesCatalogueApplicability.filter(x => x.commercialItemCode.indexOf(packageCode) !== -1).length === 0)) {
            const tempCiItem = this.salesCatalogueCommercialItems.salesCatalogues.find(x => x.code === salesCatalogueCode);
            if (tempCiItem) {
                const scPackage = tempCiItem.members?.find(member => member.type === MemberType.Package
                    && member.code === packageCode);
                if (scPackage) {
                    validCiMember.currencyCode = tempCiItem.currencyCode;
                    validCiMember.data = {
                        invoiceableItemParentCode: salesCatalogueCode,
                        code: scPackage.code,
                        name: scPackage.name,
                        price: scPackage.price,
                        comment: '',
                        type: AnalysisType.SalesCataloguePackage,
                    };
                }
            }
        }
        return {
            data: validCiMember?.data,
            currencyCode: validCiMember?.currencyCode,
            isValid: validCiMember && validCiMember.data !== undefined,
        };
    }

    validateSalesCatalogueTestBundle(testBundleCode: string, testCode: string, salesCatalogueCode: string)
        : CommercialItemValidationResponse {
        const validCiMember: { data?: CommercialItem, currencyCode?: string } = {};
        if (!(this.useMatrix &&
            this.salesCatalogueApplicability.filter(x => x.commercialItemCode.indexOf(testBundleCode) !== -1).length === 0)) {
            const tempCiItem = this.salesCatalogueCommercialItems.salesCatalogues.find(x => x.code === salesCatalogueCode);
            if (tempCiItem) {
                const temp = tempCiItem.members?.find(member => member.type === MemberType.TestBundle
                    && member.code === testBundleCode && member.tests && member.tests.some(y => y.code === testCode));
                if (temp) {
                    const test = temp.tests.find(x => x.code === testCode);
                    if (test) {
                        validCiMember.currencyCode = tempCiItem.currencyCode;
                        validCiMember.data = {
                            testBundleCode: temp.code,
                            testBundleDisplayName: temp.name,
                            invoiceableItemParentCode: salesCatalogueCode,
                            code: test.code,
                            name: test.name,
                            comment: '',
                            price: test.price,
                            type: AnalysisType.SalesCatalogueTestBundle,
                        };
                    }
                }
            }
        }
        return {
            data: validCiMember?.data,
            currencyCode: validCiMember?.currencyCode,
            isValid: validCiMember && validCiMember.data !== undefined,
        };
    }
}
